import React from 'react';
import { TouchableOpacity } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { FontAwesome5 } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import { styles } from './styles'
import LocationChange from './LocationChange';
import DescriptionChange from './DescriptionChange';
import ImageChange from './ImageChange';
import FileChange from './FileChange';
import CaptionChange from './CaptionChange';
import MilestoneChange from './MilestoneChange';

export const ChangeItem = ({ item, acceptChange, rejectChange, makeChange, projectId }) => {

  let scrollRef = React.useRef(null);
  const linkTo = useLinkTo();

  const goBack = () => {
    // if (navigation.canGoBack()) {
    //   navigation.goBack();
    // } else {
      // linkTo(`/project/${projectId}?refresh=${Math.floor(Math.random() * 1000)}`);
      linkTo(`/projects`);
    // }
  }

  const itemOutput = () => {
    // const imageTypes = ['other', 'inspiration', 'progress'];
    if (item.type === 'location'){
      return <LocationChange item={item} acceptChange={acceptChange} rejectChange={rejectChange} makeChange={makeChange} scrollRef={scrollRef} />;
    } else if (item.type === 'description') {
      return <DescriptionChange item={item} acceptChange={acceptChange} rejectChange={rejectChange} makeChange={makeChange} scrollRef={scrollRef} />;
    // } else if (imageTypes.includes(item.type)) {
    } else if (item.type === 'image') {
      return <ImageChange item={item} acceptChange={acceptChange} rejectChange={rejectChange} scrollRef={scrollRef} />;
    } else if (item.type === 'file') {
      return <FileChange item={item} acceptChange={acceptChange} rejectChange={rejectChange} scrollRef={scrollRef} />;
    } else if (item.type === 'caption') {
      return <CaptionChange item={item} acceptChange={acceptChange} rejectChange={rejectChange} makeChange={makeChange}  scrollRef={scrollRef} />;
    } else if (item.type === 'milestones') {
      return <MilestoneChange item={item} acceptChange={acceptChange} rejectChange={rejectChange} scrollRef={scrollRef} />;
    }
  }
  return (
    <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' contentContainerStyle={styles.item} ref={scrollRef}>
      <TouchableOpacity onPress={goBack} style={{ marginVertical: 10 }}>
        <FontAwesome5 name="arrow-left" size={24} color="white" />
      </TouchableOpacity>
      {itemOutput()}
    </KeyboardAwareScrollView>
  );
}

export default ChangeItem;